export default function Rewards({ points, setPoints, setPage }) {
  const rewards = [
    { name: "ดินสอ", cost: 50 },
    { name: "ปากกา", cost: 100 },
    { name: "สมุด", cost: 150 },
    { name: "ลิควิด", cost: 200 },
  ];

  const handleRedeem = (reward) => {
    if (points >= reward.cost) {
      setPoints(points - reward.cost);
      alert(`แลก ${reward.name} สำเร็จ!`);
    } else {
      alert("แต้มไม่พอแลกของรางวัลนี้");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-start bg-gradient-to-b from-blue-400 via-red-400 to-red-600 p-6">
      <h1 className="text-3xl font-bold text-white mt-6 mb-8 text-center">
        แลกของรางวัล
      </h1>

      <div className="bg-white p-6 rounded-3xl shadow-lg w-full max-w-md">
        {rewards.map((r, i) => (
          <div
            key={i}
            className="flex justify-between items-center mb-4 p-4 bg-gray-100 rounded-xl"
          >
            <span className="font-semibold">{r.name}</span>
            <button
              onClick={() => handleRedeem(r)}
              className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-xl font-semibold transition"
            >
              แลก ({r.cost} แต้ม)
            </button>
          </div>
        ))}

        <button
          onClick={() => setPage("dashboard")}
          className="w-full mt-4 bg-red-500 hover:bg-red-600 text-white py-3 rounded-2xl font-semibold transition"
        >
          กลับไป Dashboard
        </button>
      </div>
    </div>
  );
}
